function TwoLanguagesAdornment(language: string) {
    return (
        <div className={"letters-container"}>
            <div className={"letters"}>{language.toUpperCase()}</div>
        </div>
    );
}

export default TwoLanguagesAdornment;
